




"use strict";

export default class SliderNav {

    constructor (slider) {
        this.index = 0;
        this.slider = slider;
        this.holder = slider.querySelector('.holder');
        this.slideCount = slider.querySelectorAll('.item').length - 1;
        this.slideWidth = slider.querySelector('.item').offsetWidth;

        const sliderId = this.slider.dataset.slider;
        this.sliderNav = document.querySelector(`.slide-nav[data-slider="${sliderId}"]`);

        this.setupSlideButtons();
    }

    setupSlideButtons () {
        for ( let index = 0; index <= this.slideCount; index++ ) {
            const btn = document.createElement('button');
            btn.classList.add('btn', 'index');
            btn.dataset.index = index;
            btn.innerHTML = index;

            this.sliderNav.insertBefore(btn, this.sliderNav.querySelector('.btn.prev'));
        }

        this.sliderNavBtns = this.sliderNav.querySelectorAll(`.btn`);
        this.setupActiveButton();

        this.sliderNavBtns
            .forEach(btn =>
                btn.addEventListener('click',
                    () => this.handleSlideClick(btn)
                )
            );
    }

    setupActiveButton () {
        this.sliderNavBtns.forEach(btn => {
            if ( btn.dataset.index && parseInt(btn.dataset.index) === this.index ) {
                btn.classList.add('current');
            } else {
                btn.classList.remove('current');
            }
        });
    }

    incrementIndex () {
        this.index++;
        if ( this.index > this.slideCount ) {
            this.index = 0;
        }
    }

    decrementIndex () {
        this.index--;
        if ( this.index < 0 ) {
            this.index = this.slideCount;
        }
    }

    handleSlideClick (btn) {
        if ( btn.classList.contains('next') ) {
            this.incrementIndex();
        } else if ( btn.classList.contains('prev') ) {
            this.decrementIndex();
        } else if ( btn.dataset.index ) {
            this.index = parseInt(btn.dataset.index);
        }

        this.updateSlider();
    }

    updateSlider () {
        this.holder.style.transform = `translateX(-${(this.slideWidth+30)*this.index+5}px`;
        this.setupActiveButton();
    }
}
